export const Colors = {
  /* $accentColor: Blue */
  darkAccentColor: '#2674A9',
  accentOffColor: `#9FCBE8`,
  accentColor: '#2e8ece',
  lightAccentColor: '#eaf4fa',

  /* $errorColor: Red */
  errorColor: '#d14233',
  /* $warningColor: Orange */
  warningColor: '#e98b39',
  /* $successColor: Green */
  successColor: '#2cc36b',
  /* $primaryColor: Blue */
  primaryColor: '#2e8ece',
  /* $normalButtonColor: Light Gray */
  normalButtonColor: '#fbfcfc',

  peach: '#E993A7',
  green: '#27B462',
  blue: '#34C3F2',

  black: '#000',
  blackA10: 'rgba(0, 0, 0, 0.1)',
  blackA40: 'rgba(0, 0, 0, 0.4)',
  blackA50: 'rgba(0, 0, 0, 0.5)',
  blackA60: 'rgba(0, 0, 0, 0.6)',
  gray3: '#FAFAFA',
  gray4: '#fcfcfc',
  gray5: '#f3f4f5',
  gray54: '#e1e1e1',
  gray55: '#eaeaea',
  gray58: `#eceeee`,
  gray6: '#eff0f0',
  gray7: '#F5F6F6',
  gray8: '#d6d6d6',
  gray85: '#fcfcfc',
  highlightYellow: '#fffec5',
  gray10: '#c3c3c5',
  gray12: '#bbbbbe',
  gray15: '#bdbdbd',
  gray18: '#ddd',
  gray20: '#999',
  gray25: '#777', // used for legacy breadcrumbs
  gray30: '#717171',
  gray50: '#555',
  gray60: '#444',
  gray65: '#4d4d4d',
  gray70: `#333`,
  grayA70: 'rgba(214, 214, 214, 0.7)',
  gray97: '#F7F7F7',
  tempPink: '#f9f2f4',
  white: '#fff',
  cyanLighten100: '#ecf6fa',
  cyanLighten40: '#adddf3',
  salmon10: '#fff5f5',
  salmon50: '#ff6f49',

  bausRed: '#faeceb',

  semanticBorder: `rgba(34,36,38,.15)`,
  semanticErrorBackground: '#fff6f6',
};
